import { apiPost } from "./apiClient";

// Generic primitive behind every `POST /queries/:id/<action>` lifecycle
// transition (cancel, move-status, move-status-forward, reassign, unpark,
// notify-unavailable-parts, request-billing-details) — the modals-misc
// domain wraps this with each action's specific field mapping.
export function postQueryAction(queryPk, action, payload) {
  return apiPost(`/queries/${queryPk}/${action}`, payload).then(res => res.data);
}
